import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    ActivityPointsMultiplierTierGroupCreateRequestDto,
    ActivityType,
    WorkoutCategory,
    WorkoutTypeV2
} from '../../core/api/FitnessActivityClient';
import { injectTSDI } from '../../core/tsdi';
import { Api } from '../../core/api';
import { links } from '../../core/router';
import {
    ActivityPointsRuleForm,
    ActivityPointsRuleFormData,
    toOptionalPositiveNumber,
    toRequestTiers
} from './activity-points-rule-form';
import { WorkoutRecordingMethod } from './recording-method.types';

function toCreateRequest(
    formData: ActivityPointsRuleFormData
): ActivityPointsMultiplierTierGroupCreateRequestDto {
    return {
        activityType: formData.activityType as ActivityType,
        workoutCategory: formData.workoutCategory
            ? (formData.workoutCategory as WorkoutCategory)
            : undefined,
        workoutType:
            formData.activityType === ActivityType.WORKOUT &&
            formData.workoutType
                ? (formData.workoutType as WorkoutTypeV2)
                : undefined,
        recordingMethod:
            formData.activityType === ActivityType.WORKOUT &&
            formData.recordingMethod
                ? (formData.recordingMethod as WorkoutRecordingMethod)
                : undefined,
        requiredAverageSpeed: toOptionalPositiveNumber(
            formData.requiredAverageSpeed
        ),
        requiredCaloriesPerMinute: toOptionalPositiveNumber(
            formData.requiredCaloriesPerMinute
        ),
        priority: parseInt(formData.priority, 10),
        tiers: toRequestTiers(formData.tiers)
    };
}

export const CreateActivityPointsRule: React.FC = () => {
    const navigate = useNavigate();
    const { fitnessActivityClient } = injectTSDI(Api);

    const handleSubmit = async (formData: ActivityPointsRuleFormData) => {
        await fitnessActivityClient.admin.activityPointsMultiplierTierGroupControllerCreate(
            toCreateRequest(formData)
        );

        navigate(links.activityPointsRules());
    };

    return (
        <ActivityPointsRuleForm
            title="Create Tier Group"
            submitLabel="Create"
            submittingLabel="Creating..."
            onCancel={() => navigate(links.activityPointsRules())}
            onSubmit={handleSubmit}
        />
    );
};
